import BottomSheet from 'components/BottomSheet';
import React, { createContext, useCallback, useContext, useState } from 'react';

interface BottomSheetContextData {
  openBottomSheet(
    componentChildren: React.FC<any>,
    props?: Record<string, unknown>
  ): void;
  closeBottomSheet(): void;
  isOpenBottomSheet: boolean;
}

const BottomSheetContext = createContext<BottomSheetContextData>(
  {} as BottomSheetContextData
);

const BottomSheetProvider: React.FC = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [component, setComponent] = useState<JSX.Element | null>(null);

  const createComponent = useCallback(
    (Component: React.FC, props?: Record<string, unknown>) => {
      return <Component {...props} />;
    },
    []
  );

  const openBottomSheet = useCallback(
    (componentChildren: React.FC, props?: Record<string, unknown>) => {
      const createComponentBottomSheet = createComponent(
        componentChildren,
        props
      );

      setComponent(createComponentBottomSheet);
      setOpen(true);
    },
    [createComponent]
  );

  const closeBottomSheet = useCallback(() => {
    setComponent(null);
    setOpen(false);
  }, []);

  return (
    <BottomSheetContext.Provider
      value={{ openBottomSheet, closeBottomSheet, isOpenBottomSheet: open }}
    >
      {children}
      <BottomSheet isOpen={open} setOpen={setOpen} component={component} />
    </BottomSheetContext.Provider>
  );
};

function useBottomSheet(): BottomSheetContextData {
  const context = useContext(BottomSheetContext);

  if (!context) {
    throw new Error('useBottomSheet must be used within a BottomSheetProvider');
  }

  return context;
}

export { BottomSheetProvider, useBottomSheet };
